module.exports = __webpack_public_path__ + "img/minus.a0a71994.svg";